import React from 'react';

export default function Xmark({ iconClass }: { iconClass?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      aria-hidden="true"
      focusable="false"
      role="img"
      className={iconClass}
    >
      <path d="m135.5 169-17-17 33.9-33.9 17 17 151 151 151-151 17-17 33.9 33.9-17 17-151 151 151 151 17 17-33.9 33.9-17-17-151-151-151 151-17 17-33.9-33.9 17-17 151-151z" />
    </svg>
  );
}
